import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticleSection() {
  return (
    <section id="articles" className="w-full py-14 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="text-xs md:text-sm text-foreground-500 font-medium tracking-wide mb-3">
              / SEO RESOURCES &amp; GUIDES
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-4">
              Learn ACBuySpreadsheet
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              Master the acbuyspreadsheet framework with our in-depth guides, comparisons, and optimization tutorials.
            </p>

            <div className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-4 py-1.5 rounded-full mt-5">
              <i className="ri-star-fill text-accent-400 text-sm"></i>
              <span className="text-sm font-semibold">10 Expert Guides</span>
            </div>
          </div>

          {/* Article cards grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {articles.map((article, idx) => (
              <article
                key={article.slug}
                className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 flex flex-col"
              >
                {/* Article image */}
                <Link to={`/article/${article.slug}`} className="block aspect-[16/10] overflow-hidden cursor-pointer">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={`ACBuySpreadsheet — ${article.title}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading={idx < 6 ? "eager" : "lazy"}
                  />
                </Link>

                {/* Article content */}
                <div className="p-4 md:p-5 flex flex-col flex-1">
                  {/* Category badge */}
                  <div className="flex items-center gap-3 mb-3">
                    <span className="inline-block px-2.5 py-0.5 bg-accent-100/70 text-accent-700 text-xs font-semibold rounded-full whitespace-nowrap">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime}</span>
                  </div>

                  {/* Title */}
                  <Link to={`/article/${article.slug}`} className="block cursor-pointer mb-2">
                    <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                      {article.title}
                    </h3>
                  </Link>

                  {/* Intro */}
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4 flex-1">
                    {article.intro}
                  </p>

                  {/* Bottom row */}
                  <div className="flex items-center justify-between pt-3 border-t border-background-200/50">
                    <span className="flex items-center gap-1 text-xs text-foreground-400">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                      {article.rating}
                    </span>
                    <Link
                      to={`/article/${article.slug}`}
                      className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Read More
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}